import React from 'react';
import { AppRoute } from '../AppRoute';
import { AuthenticationConsumer } from '../core/services/AuthenticationProvider';
import { Loader } from '../core/components';

type PropsType = {
    path: string,
    exact?: boolean,
    component: any, 
    layout?: any
} 

export const PrivateRoute = (props: PropsType) => {
    return ( 
        <AuthenticationConsumer>
            {({userManager, isAuthenticated}) => {
                if (isAuthenticated == null){
                    return <div>Authenticating... </div>
                }                

                if (!isAuthenticated){
                    localStorage.setItem("redirectUri", window.location.pathname);
                    userManager?.signinRedirect();
                }
                return (
                    isAuthenticated ? 
                    <AppRoute exact={props.exact} path={props.path} component={props.component} layout={props.layout} />
                    :                     
                    <Loader main={true} opacity={1} />
                )
            }}
        </AuthenticationConsumer>

    );
}